import { useQuery } from "@tanstack/react-query"

import { usePartnerCode } from "@/features/PartnerCode"

import { bffApi } from "../apiClient"
import formatStartDate from "../helpers/formatStartDate"
import { Product, ProductType } from "../models"
import queryKeys from "../queryKeys"

interface ProductsResponse {
  products: Product[]
  productIds: string[]
  capacityGroupIds: string[]
  productTypeId: ProductType
}

export interface UseProductsOptions {
  resortId?: number
  arrivalDate: Date
  encodedProductIds: string
  categoryId?: number
}

const useProducts = (options: UseProductsOptions) => {
  const { resortId, arrivalDate, encodedProductIds, categoryId } = options
  const formattedDate = formatStartDate(arrivalDate)
  const { partnerCode } = usePartnerCode()

  const enabled =
    Boolean(resortId) &&
    Boolean(arrivalDate) &&
    Boolean(encodedProductIds) &&
    Boolean(categoryId)

  return useQuery<ProductsResponse>({
    queryKey: queryKeys.products({
      resortId,
      arrivalDate: formattedDate,
      categoryId,
      encodedProductIds,
      partnerCode,
    }),
    queryFn: async () => {
      const params = {
        ...options,
        arrivalDate: formattedDate,
        partnerCode,
      }
      const res = await bffApi.get<ProductsResponse>(`/products`, {
        params: params,
      })
      return res.data
    },
    enabled: enabled,
  })
}

export default useProducts
